<div class="auth-page">
  <div class="brand-logo">Flwx</div>

  <div class="auth-center">
    <div class="card auth-card shadow-sm border-0">
      <div class="card-body p-4 p-md-5">
        <h4 class="mb-4 fw-semibold">Login</h4>

        <form [formGroup]="form" (ngSubmit)="onLogin()">
          <div class="mb-3">
            <label class="form-label">Email/Username</label>
            <input type="text" class="form-control" formControlName="emailOrUsername" placeholder="Enter username" />

            @if (emailOrUsernameControl?.touched && emailOrUsernameControl?.errors?.['required']) {
            <div class="field-error">Username is required.</div>
            }
          </div>

          <div class="mb-2">
            <label class="form-label">Password</label>
            <input type="password" class="form-control" formControlName="password" placeholder="Enter password" />

            @if (passwordControl?.touched && passwordControl?.errors?.['required']) {
            <div class="field-error">Password is required.</div>
            }

            @if (passwordControl?.touched && passwordControl?.errors?.['minlength']) {
            <div class="field-error">Password must be at least 6 characters.</div>
            }
          </div>

          <!-- Forgot Password - hidden, activate when ready
          <div class="text-end mb-3">
            <a routerLink="/auth/forgot-password" class="small text-decoration-none">
              Forgot Password?
            </a>
          </div>
          -->

          @if (errorMessage) {
          <div class="alert alert-danger py-2 mb-3">{{ errorMessage }}</div>
          }

          <button type="submit" class="btn btn-primary w-100" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Logging in...' : 'Login' }}
          </button>
        </form>

        <div class="signup-link-block mt-3">
          <span class="signup-text">Don’t have a company account?</span>
          <a routerLink="/auth/company-signup" class="signup-link">Company Signup</a>
        </div>

      </div>
    </div>
  </div>
</div>